import type { Template } from "@/types";

export const LA_06_H2_V4: Template[] = [
{
    id: "la-06-h2v4-01",
    name: "LA 01 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 61, y: 48, width: 241, height: 383, rotation: 0, imageRotation: 0 },
            { id: "2", x: 310, y: 48, width: 266, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 310, y: 243, width: 266, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 744, y: 48, width: 277, height: 383, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1029, y: 48, width: 141, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1029, y: 243, width: 141, height: 187, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-02",
    name: "LA 02 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 164, y: 31, width: 310, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 743, y: 31, width: 315, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 743, y: 242, width: 315, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1065, y: 31, width: 110, height: 134, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1065, y: 172, width: 110, height: 133, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1065, y: 312, width: 110, height: 133, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-03",
    name: "LA 03 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 165, y: 48, width: 306, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 165, y: 241, width: 306, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 809, y: 48, width: 142, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 809, y: 241, width: 142, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 48, width: 142, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 241, width: 142, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-04",
    name: "LA 04 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 113, y: 45, width: 132, height: 190, rotation: 0, imageRotation: 0 },
            { id: "2", x: 253, y: 45, width: 271, height: 190, rotation: 0, imageRotation: 0 },
            { id: "3", x: 113, y: 242, width: 132, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 253, y: 242, width: 132, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 392, y: 242, width: 132, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 723, y: 82, width: 466, height: 313, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-05",
    name: "LA 05 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 111, y: 44, width: 415, height: 247, rotation: 0, imageRotation: 0 },
            { id: "2", x: 111, y: 299, width: 99, height: 134, rotation: 0, imageRotation: 0 },
            { id: "3", x: 217, y: 299, width: 99, height: 134, rotation: 0, imageRotation: 0 },
            { id: "4", x: 322, y: 299, width: 99, height: 134, rotation: 0, imageRotation: 0 },
            { id: "5", x: 428, y: 299, width: 98, height: 134, rotation: 0, imageRotation: 0 },
            { id: "6", x: 723, y: 82, width: 466, height: 313, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-06",
    name: "LA 06 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 61, y: 65, width: 449, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 518, y: 65, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 518, y: 242, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 643, y: 65, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 643, y: 242, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "6", x: 767, y: 65, width: 447, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-07",
    name: "LA 07 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 60, y: 65, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "2", x: 60, y: 242, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 185, y: 65, width: 449, height: 346, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 65, width: 118, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 242, width: 118, height: 169, rotation: 0, imageRotation: 0 },
            { id: "6", x: 767, y: 65, width: 447, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-08",
    name: "LA 08 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 61, y: 65, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 242, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 186, y: 65, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 186, y: 242, width: 117, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 310, y: 65, width: 449, height: 346, rotation: 0, imageRotation: 0 },
            { id: "6", x: 767, y: 65, width: 447, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-09",
    name: "LA 09 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 47, width: 497, height: 385, rotation: 0, imageRotation: 0 },
            { id: "2", x: 504, y: 47, width: 130, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 504, y: 243, width: 130, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 47, width: 496, height: 385, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1145, y: 47, width: 129, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1145, y: 243, width: 129, height: 188, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h2v4-10",
    name: "LA 10 - H2V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 65, width: 519, height: 348, rotation: 0, imageRotation: 0 },
            { id: "2", x: 527, y: 65, width: 107, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 527, y: 243, width: 107, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 65, width: 106, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 243, width: 106, height: 169, rotation: 0, imageRotation: 0 },
            { id: "6", x: 756, y: 65, width: 518, height: 348, rotation: 0, imageRotation: 0 }
    ],
}
];